import ServiceContracts from '../ServiceContracts/ServiceContracts';
import Cart from '../Cart';
import CustomerInfo from '../CustomerInfo/CustomerInfo';
import useValidateCartPage from '../Hooks/ValidateCartPageHook';
import ShippingMethod from '../ShippingMethod/ShippingMethod';
import { ICartWorkflowWizardStep } from './CartWorkflowWizard.types';
import ReviewOrder from '../ReviewOrder/ReviewOrder';
import NextSteps from '../NextSteps/NextSteps';
import Payment from '../Payment/Payment';
import PickNumber from '../PickNumber/PickNumber';
import { ReserveNumbersHook } from '../Hooks/IdiCart/ReserveNumbersHook';
import useValidatePickNumberPage from '../Hooks/PickNumber/ValidatePickNumberPageHook';
import useValidateShippingMethodPage from '../Hooks/ShippingMethod/ValidateShippingMethodPageHook';
import useValidateCustomerInfoPage from '../Hooks/CustomerInfo/ValidateCustomerInfoPageHook';

const useCartWorkflow = (): ICartWorkflowWizardStep[] => {
    const cartStep: ICartWorkflowWizardStep = {
        title: 'Cart',
        proceedText: 'Checkout',
        validationHook: useValidateCartPage,
        component: <Cart />
    };

    const customerInfoStep: ICartWorkflowWizardStep = {
        title: 'Personal Info',
        proceedText: 'Proceed to Shipping',
        validationHook: useValidateCustomerInfoPage,
        component: <CustomerInfo />
    };

    const shippingMethodStep: ICartWorkflowWizardStep = {
        title: 'Shipping',
        proceedText: 'Proceed to Pick Number',
        validationHook: useValidateShippingMethodPage,
        component: <ShippingMethod />
    };

    const pickNumberStep: ICartWorkflowWizardStep = {
        title: 'Pick Number',
        proceedText: 'Proceed to Service Contracts',
        validationHook: useValidatePickNumberPage,
        onProceed: ReserveNumbersHook,
        component: <PickNumber />
    };

    const serviceContractsStep: ICartWorkflowWizardStep = {
        title: 'Service Contracts',
        component: <ServiceContracts />
    };

    const reviewOrderStep: ICartWorkflowWizardStep = {
        title: 'Review order',
        proceedText: 'Proceed to Payment',
        component: <ReviewOrder />
    };

    const paymentStep: ICartWorkflowWizardStep = {
        title: 'Payment',
        component: <Payment />
    };

    const nextStepsStep: ICartWorkflowWizardStep = {
        title: 'Next Steps',
        component: <NextSteps />,
        hideSummary: true
    };

    return [
        cartStep,
        customerInfoStep,
        shippingMethodStep,
        pickNumberStep,
        serviceContractsStep,
        reviewOrderStep,
        paymentStep,
        nextStepsStep
    ];
};

export default useCartWorkflow;
